import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
export const initialState = {
  sourceSystems: [],
  status: '',
  error: null,
};
export const fetchSourceSystems = createAsyncThunk(
  'master/fetchSourceSystems',
  async (_, { getState, rejectWithValue }) => {
    const { sourceSystems } = getState().sourceSystems;

    if (sourceSystems && sourceSystems.length > 0) {
      return rejectWithValue('categories already fetched');
    } else {
      const response = await ApiService.get('/system/source-system');
      return response;
    }
  }
);
const sourceSystemSlice = createSlice({
  name: 'sourceSystems',
  initialState,
  reducers: {
    clearSourceSystems: state => {
      state.sourceSystems = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSourceSystems.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchSourceSystems.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.sourceSystems = action?.payload || [];
      })
      .addCase(fetchSourceSystems.rejected, (state, action) => {
        if (action.payload === 'source system already fetched') {
          state.status = 'succeeded';
        } else {
          state.status = 'failed';
          state.error = action.error.message;
        }
      });
  },
});

export const { clearSourceSystems } = sourceSystemSlice.actions;

export const sourceSystemReducer = sourceSystemSlice.reducer;
